export const nameIsValid = (name: string): boolean => {
  if (name === '') {
    return false
  } else {
    return true
  }
}
